/**
 * Main Application Entry Point
 * Orchestrates vendor libraries and fragments with explicit initialization
 */

// Import vendor setup
import { htmx } from './vendor/htmx.js';

// Import utilities
import { Events } from './utils/events.js';
// Import fragment initializers (no side effects)
import {
    initCommon,
    initContact,
    initAccountUser,
    initRepositoryExplorer,
    initRepositoryCopy,
    initRepository,
    initPortalExplorer,
    initPortal,
    initPortalCopy,
    initGuest,
    initTransfer,
    initTransferIncoming,
    initTransferOutgoing,
    initTransferDraft,
    initLogin,
    initMfa,
    initChat,
    initFeedback,
    initBranding,
    initOutlookLogin,
    initObservation,
    initSchedule,
    initDesktopClient,
} from './fragments.js';

// ============================================================================
// Application Initialization
// ============================================================================

document.addEventListener('DOMContentLoaded', () => {
    // Initialize common components
    initCommon();

    // Initialize all fragments
    initContact();
    initAccountUser();

    // Repository fragments
    initRepositoryExplorer();
    initRepositoryCopy();
    initRepository();

    // Portal fragments
    initPortalExplorer();
    initPortal();
    initPortalCopy();
    initGuest();

    // Transfer fragments
    initTransfer();
    initTransferIncoming();
    initTransferOutgoing();
    initTransferDraft();

    // Login fragment
    initLogin();

    // MFA fragment
    initMfa();

    // Chat fragment (captcha gate handler)
    initChat();

    // Feedback modal
    initFeedback();

    // Branding
    initBranding();

    // Outlook dialog handoff
    initOutlookLogin();

    // Event monitoring console
    initObservation();

    // Schedule delivery modal
    initSchedule();

    // Desktop client settings
    initDesktopClient();

    console.log('[LeapFILE] Bundle loaded');
});

// Export for external access if needed
export { htmx, Events };
